import * as React from 'react'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import trovityLogo from 'src/assets/Header_Images/trovityLogo.svg'
import { useHistory } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { makeStyles } from '@material-ui/core/styles'

const ErrorDialog = (props) => {
  const classes = useStyles()

  const [open, setOpen] = React.useState(true)
  const handleClose = () => {
    setOpen(false)
  }
  const history = useHistory()
  const backFunction = (func) => {
    if (func === 'back') {
      return history.goBack()
    } else {
      const browserHistory = createBrowserHistory({ forceRefresh: true })
      return browserHistory.push('/individual/dashboard')
    }
  }
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose || 'backdropClick'}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        data-test='mainDialog'
      >
        <div className={classes.dialogContainer}>
          <DialogTitle id='alert-dialog-title' data-test='dialogTitle'>
            <div className={classes.imgContainer}>
              <img src={trovityLogo} alt='logo' textAlign='center' />
            </div>
          </DialogTitle>
          <DialogContent data-test='dialogContent'>
            <DialogContentText id='alert-dialog-description'>
              <Alert severity='warning'>{props?.message}</Alert>
            </DialogContentText>
          </DialogContent>
          <DialogActions justifyContent={'center'}>
            <div className={classes.btnContainer}>
              <Button
                variant='outlined'
                onClick={() => backFunction(props?.routeValue)}
                data-test='buttonClick'
              >
                OK
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  )
}

export default ErrorDialog

const useStyles = makeStyles({
  dialogContainer: {
    padding: '10px',
  },
  imgContainer: {
    textAlign: 'center',
  },
  btnContainer: {
    textAlign: 'center',
  },
})
